<template>
  <div v-bind="$attrs">
    <span :class="textClass">{{ starNumber }}つ星ホテル</span>
    <img v-for="(starUrl, index) in starUrls" :key="index" :src="starUrl" />
  </div>
</template>

<script>
const starOnUrl = require('@ota-frontend/shared-assets/images/dp/star_on.svg')
const starOffUrl = require('@ota-frontend/shared-assets/images/dp/star_off.svg')

export default {
  name: 'TkStarRating',
  props: {
    maxStar: {
      type: Number,
      default: 5,
    },
    starNumber: {
      type: Number,
      default: 0,
    },
    textClass: {
      type: String,
      default: 'tourHotelSelectRoom_ratesText',
    },
  },
  computed: {
    starUrls() {
      return [...Array(this.maxStar).keys()].map((index) => {
        return index < this.starNumber ? starOnUrl : starOffUrl
      })
    },
  },
}
</script>
